import { render, staticRenderFns } from "./22-member-profile-extras.vue?vue&type=template&id=3119f081&scoped=true"
import script from "./22-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./22-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./22-member-profile-extras.vue?vue&type=style&index=0&id=3119f081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119f081",
  null
  
)

export default component.exports